
export interface UsuarioVm {
    publicId: string;
    nomeCompleto: string;
    apelido: string;
    cpf: string;
    cpfFormatado: string
    celular: string;
    imagem: string;
    email: string;
    status: number;
    statusDescricao: string;
    isLoginHabilitado: boolean;
    permissoes:string[]

}


export interface UsuarioStoreVm {
    publicId: string
    nome: string
    apelido:string
    imagem: string
    email: string
    sessao: string
    status: EStatusUsuario
    permissoes:string[]
}

export enum EStatusUsuario {
    Cadastrado = 1,
    Confirmado = 2,
    Desativado = 3
}


export interface UsuarioSessoesVm {
    sessao: string;
    dispositivo: string;
    navegador: string;
    ip: string;
    ultimoIp:string;
    dataSessao: string;
    dataUltimaVerificacao: string;
}


